module.exports = __webpack_public_path__ + "img/RecibidaIcon.9aa96081.svg";